import { useMemo } from "react";

import type { TriggerFn } from "../../../../vendor/LexicalTriggerMenuPlugin";
import type { ConfigurableVariableOption } from "../../ConfigurableVariableOption";

type MatchProps = {
    options: Array<ConfigurableVariableOption>;
    denylist: Array<string>;
};

export function useTypeaheadFilterMatch({ options, denylist }: MatchProps): {
    triggerCallbacks: Array<TriggerFn>;
} {
    const firstLetterCallback = useMemo(() => {
        return options.map((_val) => {
            // return a callback for each custom option where the matching string is the first letter of the custom option text
            return (text: string) => {
                if (options.length && !denylist.some((deny) => text.includes(deny))) {
                    return {
                        leadOffset: 0,
                        replaceableString: text,
                        matchingString: text,
                        openingTag: "",
                        closingTag: "",
                    };
                }
            };
        });
    }, [options, denylist]);

    return {
        triggerCallbacks: firstLetterCallback,
    };
}
